module.exports = __webpack_public_path__ + "img/icon_send.f997e087.svg";